import React from 'react'
import { Link } from 'newComponents'

import './styles.scss'

const BlogButton = (props) => {
  const { to: slug, children, className, removeBlogPath, onClick = () => {}, ignoreQuery } = props

  const linkTo = slug ? `/blog/${slug}` : '#'

  return (
    <div className={`blog-button-container ${className || ''}`}>
      <Link
        to={removeBlogPath ? slug : `/blog/${slug}`}
        className="blog-button"
        onClick={onClick}
        ignoreQuery={ignoreQuery}
      >
        {children}
      </Link>
    </div>
  )
}

export default BlogButton
